import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { transient } from '@lichtblick/styled';
import { forwardRef } from 'react';
import { Tooltip } from '../../organisms/Tooltip';
import { FieldFooter } from '../FieldFooter/FieldFooter';
import { Label } from '../Label/Label';
import { InfoIcon, Input, InputRow, LabelWrapper, LeftSlot, RightSlot, StyledSubLabel, SuffixText, Wrapper } from './Textfield.styles';
/**
 * Generic text input component with some basic setup to be used as foundation for all kinds of text input types.
 * Ref needs to be forwarded to be compatible with form packages like react-hook-form.
 */ export const Textfield = /*#__PURE__*/ forwardRef(({ className, 'data-testid': testId, icon, id, isBold, isCentered, isDisabled, label, leftSlot, name, onTooltipClick, rightSlot, statusLabel, statusType, subLabel, suffixText, tooltipContent, ...props }, ref)=>{
    const inputId = id || name;
    const labelId = inputId && `${inputId}_label`;
    const statusId = inputId && `${inputId}_validationMessage`;
    return /*#__PURE__*/ _jsxs(Wrapper, {
        className: className,
        children: [
            Boolean(label || onTooltipClick || tooltipContent) && /*#__PURE__*/ _jsxs(LabelWrapper, {
                children: [
                    Boolean(label) && /*#__PURE__*/ _jsxs(Label, {
                        htmlFor: inputId,
                        id: labelId,
                        isBold: true,
                        children: [
                            label,
                            Boolean(subLabel) && /*#__PURE__*/ _jsx(StyledSubLabel, {
                                size: "Xs",
                                children: subLabel
                            })
                        ]
                    }),
                    (Boolean(onTooltipClick) || Boolean(tooltipContent)) && /*#__PURE__*/ _jsx(Tooltip, {
                        content: tooltipContent,
                        children: /*#__PURE__*/ _jsx(InfoIcon, {
                            onClick: onTooltipClick
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(InputRow, {
                $isDisabled: isDisabled,
                $statusType: statusType,
                children: [
                    leftSlot && /*#__PURE__*/ _jsx(LeftSlot, {
                        children: leftSlot
                    }),
                    /*#__PURE__*/ _jsx(Input, {
                        ...props,
                        ...transient({
                            isBold,
                            isCentered
                        }),
                        $hasLeftSlot: Boolean(leftSlot),
                        $hasRightSlot: Boolean(rightSlot),
                        "aria-describedby": statusId,
                        "aria-invalid": statusType === 'error',
                        "aria-labelledby": labelId,
                        "data-testid": testId || inputId,
                        disabled: isDisabled,
                        id: inputId,
                        name: name,
                        ref: ref
                    }),
                    Boolean(rightSlot || suffixText) && /*#__PURE__*/ _jsxs(RightSlot, {
                        children: [
                            Boolean(suffixText) && /*#__PURE__*/ _jsx(SuffixText, {
                                isBold: true,
                                children: suffixText
                            }),
                            rightSlot
                        ]
                    })
                ]
            }),
            Boolean(statusLabel) && /*#__PURE__*/ _jsx(FieldFooter, {
                fieldFooterLabel: statusLabel,
                fieldFooterType: statusType,
                icon: icon,
                id: statusId
            })
        ]
    });
});

//# sourceMappingURL=Textfield.js.map